import RedoEntryButton from "./RedoEntryButton";
import {useState} from "react";
import DeleteEntryButton from "./DeleteEntryButton";
import RedoEntryModal from "./RedoEntryModal";
import DeleteEntryModal from "./DeleteEntryModal";
import {contributorLockReason, lockedForContributor} from "./reviewStatus";

export default function ActionsRow({entry, deleteEntry, editEntry, job, inspector, asCell = true}) {
	const [redoLoading, setRedoLoading] = useState(false);
	const [deleteLoading, setDeleteLoading] = useState(false);

	// Once a verdict takes the entry out of the contributor's hands, Edit and Delete grey out
	// rather than disappear, so it is visible that the entry is settled and not that the buttons
	// are missing. An inspector is not bound by their own verdict.
	const locked = !inspector && lockedForContributor(entry);
	const lockReason = contributorLockReason(entry);

	const buttons = (
		<div className={"d-flex gap-1 flex-shrink-0"}>
			{/* Delete is the contributor's own tool for their own mistake. PM and QA reject
			    instead, so that a bad asset stays on record with a reason attached —
			    losing that history is what the per-entry verdict exists to fix. */}
			{!inspector && job.entryInstructions.length === 0 && <DeleteEntryButton entry={entry} loading={deleteLoading} locked={locked} lockReason={lockReason} />}
			<RedoEntryButton entry={entry} loading={redoLoading} locked={locked} lockReason={lockReason} />
		</div>
	);

	return (
		<>
			<RedoEntryModal entry={entry} editEntry={editEntry} loading={redoLoading} setLoading={setRedoLoading} />
			<DeleteEntryModal entry={entry} deleteEntry={deleteEntry} loading={deleteLoading} setLoading={setDeleteLoading} />
			{asCell ? (
				<td className={"position-sticky text-nowrap"} style={{right: 0, width: '135px'}}>
					{buttons}
				</td>
			) : buttons}
		</>
	);
}
